/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { useCurrentContactActions } from "../../hooks/useCurrentContactActions";
import VoicemailAudio from "./VoicemailAudio";
import VoicemailDetails from "./VoicemailDetails";

const VoicemailTab = ({ contact, renderToastContent }) => {
	const { callToNumber } = useCurrentContactActions();
	let { attributes } = contact;

	const initiateOutboundCall = async () => {
		const phoneNumber = attributes.find((attr) => attr.name === "contactPhoneNumber")?.value || "";
		if (phoneNumber) {
			try {
				await callToNumber(phoneNumber);
				renderToastContent(true, "Successfully initiated callback.", "success");
			} catch (e) {
				const error = JSON.parse(e);
				renderToastContent(true, error.message, "danger");
			}
		}
	};

	const detailsAttributes = [
		{
			name: "phoneNumber",
			value: attributes.find((attr) => attr.name === "contactPhoneNumber")?.value || "",
		},
		{
			name: "originalContactId",
			value: attributes.find((attr) => attr.name === "vm_originalContactId")?.value || "",
		},
	];
	const transcript = attributes.find((attr) => attr.name === "transcript");
	if (transcript) {
		transcript.copy = false;
		detailsAttributes.push(transcript);
	}
	attributes = attributes.map((attr) => ({ ...attr, id: attr.name }));
	const audioFile = attributes.find((attr) => attr.name === "audioFile");
	return (
		<div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
			{audioFile && (
				<div style={{ padding: "15px 30px", display: "flex", width: "100%" }}>
					<span
						style={{
							wordBreak: "break-all",
							width: "100%",
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							columnGap: "20px",
						}}
					>
						<div style={{ width: "100%", display: "inline" }}>
							<VoicemailAudio audioFileKey={audioFile.value} />
						</div>
					</span>
				</div>
			)}
			<div style={{ padding: "15px 30px", display: "flex", width: "100%" }}>
				<VoicemailDetails attributes={detailsAttributes} initiateOutboundCall={initiateOutboundCall} />
			</div>
		</div>
	);
};

export default VoicemailTab;
